const initOrderSuccessModal = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('order-success') !== '1') {
    return;
  }

  if (!window.modals) {
    return;
  }

  window.modals.open('order-success');
  setTimeout(() => {
    window.modals.close('order-success');
  }, 3000);

  window.history.replaceState(
    {},
    '',
    window.location.pathname
  );
};

export {initOrderSuccessModal};
